"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
exports.default = createIconComponent_1.default("Add", React.createElement("path", { fill: "currentColor", d: "M12,0.3C5.6,0.3,0.3,5.6,0.3,12S5.6,23.8,12,23.8S23.8,18.4,23.8,12S18.4,0.3,12,0.3z M19,12.7h-6.3v6.7h-1.6v-6.7H4.7v-1.6\nh6.4V5h1.6v6.1H19V12.7z" }));
//# sourceMappingURL=Add.js.map